'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (Sliders, $) {
		var $dom = {};
		var arrow = '<svg viewBox="0 0 15 27" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon-arrow-left-reviews"><path d="M12.0018397,13.2302866 L0.84526814,2.08500706 C0.366674393,1.60689772 0.366674393,0.836481724 0.84526814,0.358372383 C1.32358211,-0.119457461 2.09390539,-0.119457461 2.57221936,0.358372383 L14.5956536,12.3696372 C15.0708721,12.8443747 15.0680492,13.6227191 14.5903122,14.0909359 L2.57348823,26.0954714 C2.34378713,26.3337657 2.02915963,26.4619071 1.70607306,26.4619071 C1.38832273,26.4619071 1.07532417,26.3320239 0.84526814,26.1022007 C0.366674393,25.6240914 0.366674393,24.8536754 0.84526814,24.3755661 L12.0018397,13.2302866 Z"></path></g></svg>';
		var arrowblack = '<svg viewBox="0 0 15 27" fill="#3D3D38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon-arrow-left-reviews"><path d="M12.0018397,13.2302866 L0.84526814,2.08500706 C0.366674393,1.60689772 0.366674393,0.836481724 0.84526814,0.358372383 C1.32358211,-0.119457461 2.09390539,-0.119457461 2.57221936,0.358372383 L14.5956536,12.3696372 C15.0708721,12.8443747 15.0680492,13.6227191 14.5903122,14.0909359 L2.57348823,26.0954714 C2.34378713,26.3337657 2.02915963,26.4619071 1.70607306,26.4619071 C1.38832273,26.4619071 1.07532417,26.3320239 0.84526814,26.1022007 C0.366674393,25.6240914 0.366674393,24.8536754 0.84526814,24.3755661 L12.0018397,13.2302866 Z"></path></g></svg>';

		var cacheDom = function cacheDom() {
			$dom.testimonialSlider = $('[data-testimonial-slider]');

			$dom.testimonialSliderQuotes = $('[data-testimonials-slider-quotes]');
			$dom.testimonialSliderLogos = $('[data-testimonials-slider-logos]');

			$dom.testimonialStorySlider = $('[data-story-testimonial-slider]');

			$dom.productMobileSlider = $('[data-mobile-product-slider]');

			$dom.pressPageSlider = $('[data-mention-slider-quotes]');
			$dom.pressPageSliderLogos = $('[data-mentions-slider-logos]');

			$dom.mediaPageSlider = $('[data-media-mention-slider-quotes]');
			$dom.mediaPageSliderLogos = $('[data-media-mentions-slider-logos]');

			$dom.pressLogoSlider = $('[data-press-logo-slider]');

			$dom.pdpPageResult = $('[data-pdp-result-slider]');

			$dom.pdpPageImageSlider = $('[data-pdp-image-slider]');

			$dom.pdpPageSliderThumb = $('[data-pdp-sliderthumb-slider]');

			$dom.pressPopupSlider = $('[data-press-popup-slider]');

			$dom.pdpSkinSliderThumb = $('[data-pdp-skin-slider-thumb]');

			$dom.pdpSkinSlider = $('[data-pdp-skin-slider]');

			$dom.resultReportSlider = $('[data-result-report-slider]');

			$dom.howToQuoteSlider = $('[data-how-to-quote-slider]');

			$dom.scienceManSlider = $('[data-science-man-slider]');

			$dom.scienceManSliderNav = $('[data-science-man-slide-nav]');

			$dom.pdpLinkSlider = $('[data-pdpLinkSlider]');

			$dom.reviewSlider = $('[data-reviewSlider]');

			$dom.reviewHighlightSlider = $('[data-reviewHighlightSlider]');
		};

		var SlidersInit = function SlidersInit() {

			var pdpLinkOptions = {
				mobileFirst: true,
				dots: false,
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '30px',
				infinite: true,
				autoplay: true,
				responsive: [{
					breakpoint: 640,
					settings: "unslick"
				}]
			};

			$dom.pdpLinkSlider.slick(pdpLinkOptions);

			$dom.pdpLinkSlider.click(function () {
				$dom.pdpLinkSlider.slick('slickPause');
			});

			var reviewSliderOptions = {
				dots: false,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 7000,
				prevArrow: '<span class="slick-arrow slick-prev">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrow slick-next">' + arrow + '</span>'
			};

			$dom.reviewSlider.slick(reviewSliderOptions);

			var reviewHighlightSliderOptions = {
				mobileFirst: true,
				dots: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 7000,
				arrows: true,
				prevArrow: '<span class="slick-arrows slick-arrows--prev">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrows slick-arrows--next">' + arrow + '</span>',
				responsive: [{
					breakpoint: 1023,
					settings: "unslick"
				}]
			};

			$dom.reviewHighlightSlider.slick(reviewHighlightSliderOptions);

			var testimonialOptions = {
				dots: false,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				fade: true,
				speed: 0,
				prevArrow: '<span class="slick-arrow slick-prev">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrow slick-next">' + arrow + '</span>',
				adaptiveHeight: true,
				responsive: [{
					breakpoint: 768,
					settings: {
						dots: true,
						arrows: false
					}
				}]
			};
			$dom.testimonialSlider.slick(testimonialOptions);
			$dom.testimonialStorySlider.slick(testimonialOptions);

			var pressPageSliderOptions = {
				dots: false,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				asNavFor: $dom.pressPageSliderLogos,
				infinite: true,
				autoplay: true,
				adaptiveHeight: true,
				autoplaySpeed: 3500,
				prevArrow: '<span class="slick-arrow slick-prev slick-prev--press">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrow slick-next slick-next--press">' + arrow + '</span>',
				pauseOnHover: true
			};

			var mediaPageSliderOptions = {
				dots: false,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				asNavFor: $dom.mediaPageSliderLogos,
				infinite: true,
				autoplay: true,
				adaptiveHeight: false,
				autoplaySpeed: 3500,
				prevArrow: '<span class="slick-arrow slick-prev slick-prev--press">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrow slick-next slick-next--press">' + arrow + '</span>',
				pauseOnHover: true
			};

			var numPressPageLogos = document.querySelectorAll('[data-press-mention-logo]').length || 2;
			var pressPageSliderLogoOptions = {
				dots: false,
				arrows: false,
				slidesToShow: numPressPageLogos,
				slidesToScroll: 1,
				focusOnSelect: true,
				asNavFor: $dom.pressPageSlider,
				infinite: true,
				fade: false,
				autoplay: true,
				autoplaySpeed: 3500,
				pauseOnHover: true
			};

			var mediaPageSliderLogoOptions = {
				dots: false,
				arrows: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				focusOnSelect: true,
				asNavFor: $dom.mediaPageSlider,
				infinite: false,
				fade: false,
				autoplay: true,
				autoplaySpeed: 3500,
				pauseOnHover: true
			};

			$dom.pressPageSlider.slick(pressPageSliderOptions);
			$dom.pressPageSliderLogos.slick(pressPageSliderLogoOptions);

			$dom.mediaPageSlider.slick(mediaPageSliderOptions);
			$dom.mediaPageSliderLogos.slick(mediaPageSliderLogoOptions);

			var testimonialQuotesOptions = {
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				asNavFor: $dom.testimonialSliderLogos,
				infinite: false,
				fade: true,
				adaptiveHeight: false,
				autoplay: true,
				autoplaySpeed: 3500,
				pauseOnHover: true,
				prevArrow: '<span class="slick-arrow slick-prev">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrow slick-next">' + arrow + '</span>',
				responsive: [{
					breakpoint: 768,
					settings: {
						dots: false,
						arrows: true
					}
				}]
			};
			var testimonialLogosOptions = {
				dots: false,
				arrows: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				focusOnSelect: true,
				asNavFor: $dom.testimonialSliderQuotes,
				infinite: false,
				fade: false,
				autoplay: true,
				autoplaySpeed: 3500,
				pauseOnHover: true
			};
			$dom.testimonialSliderQuotes.slick(testimonialQuotesOptions);
			$dom.testimonialSliderLogos.slick(testimonialLogosOptions);

			var pdpPageResultOptions = {
				dots: true,
				arrows: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: 1024,
					settings: {
						dots: true,
						slidesToShow: 3,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '60px',
						infinite: true
					}
				}, {
					breakpoint: 950,
					settings: {
						dots: true,
						slidesToShow: 3,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '30px',
						infinite: true
					}
				}, {
					breakpoint: 850,
					settings: {
						dots: true,
						slidesToShow: 2,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '60px',
						infinite: true
					}
				}, {
					breakpoint: 767,
					settings: {
						dots: true,
						slidesToShow: 2,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '30px',
						infinite: true
					}
				}, {
					breakpoint: 640,
					settings: {
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '28px',
						infinite: false
					}
				}]
			};
			$dom.pdpPageResult.slick(pdpPageResultOptions);

			var pdpPageImageSliderOptions = {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				infinite: true,
				asNavFor: $dom.pdpPageSliderThumb,
				prevArrow: '<span class="slick-arrow slick-prev">' + arrowblack + '</span>',
				nextArrow: '<span class="slick-arrow slick-next">' + arrowblack + '</span>'
			};

			var pdpPageSliderThumbOptions = {
				dots: false,
				arrows: false,
				slidesToShow: 6,
				slidesToScroll: 6,
				infinite: false,
				autoplay: false,
				asNavFor: $dom.pdpPageImageSlider,
				focusOnSelect: true
			};

			$dom.pdpPageImageSlider.slick(pdpPageImageSliderOptions);
			$dom.pdpPageSliderThumb.slick(pdpPageSliderThumbOptions);

			var pressPopupSliderOptions = {
				dots: false,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 3500,
				prevArrow: '<span class="slick-arrow slick-prev slick-prev--press">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrow slick-next slick-next--press">' + arrow + '</span>'
			};

			$dom.pressPopupSlider.slick(pressPopupSliderOptions);

			var pdpSkinSliderOptions = {
				dots: false,
				asNavFor: $dom.pdpSkinSliderThumb,
				infinite: false,
				speed: 100,
				fade: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				touchMove: false,
				swipe: false,
				swipeToSlide: false,
				draggable: false,
				accessibility: false
			};

			var pdpSkinSliderThumbOptions = {
				dots: false,
				arrows: false,
				slidesToShow: 3,
				slidesToScroll: 3,
				focusOnSelect: true,
				asNavFor: $dom.pdpSkinSlider,
				infinite: false,
				fade: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '180px',
						dots: false,
						arrows: false,
						infinite: false
					}
				}, {
					breakpoint: 580,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '130px',
						dots: false,
						arrows: false,
						infinite: false
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '100px',
						dots: false,
						arrows: false,
						infinite: false
					}
				}, {
					breakpoint: 400,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '80px',
						dots: false,
						arrows: false,
						infinite: false
					}
				}]
			};

			var resultReportOptions = {
				dots: false,
				arrows: false,
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
				adaptiveHeight: true,
				responsive: [{
					breakpoint: 1023,
					settings: {
						dots: false,
						arrows: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
						adaptiveHeight: true
					}
				}, {
					breakpoint: 767,
					settings: {
						dots: false,
						arrows: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
						adaptiveHeight: true
					}
				}, {
					breakpoint: 640,
					settings: {
						dots: false,
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: false,
						adaptiveHeight: true,
						centerMode: true,
						centerPadding: '30px'
					}
				}]
			};

			$dom.resultReportSlider.slick(resultReportOptions);

			$('.c-storyCol__item').click(function () {
				$dom.resultReportSlider.slick('slickNext');
			});

			if ($(".c-storyReport__colChart").length > 0) {
				if ($(window).width() < 1023) {
					$(window).on('scroll', function () {
						var test = $('.c-storyReport__colChart').offset().top - 50;
						if ($(window).scrollTop() > test) {
							$dom.resultReportSlider.slick('slickNext');
							$(window).off('scroll');
						}
					});
				}
			}

			$dom.pdpSkinSlider.slick(pdpSkinSliderOptions);

			$dom.pdpSkinSliderThumb.slick(pdpSkinSliderThumbOptions);

			var howToQuoteSliderOptions = {
				dots: false,
				arrows: true,
				slidesToShow: 3,
				slidesToScroll: 3,
				focusOnSelect: true,
				infinite: true,
				prevArrow: '<span class="slick-arrow slick-prev">' + arrow + '</span>',
				nextArrow: '<span class="slick-arrow slick-next">' + arrow + '</span>',
				responsive: [{
					breakpoint: 1180,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			};

			$dom.howToQuoteSlider.slick(howToQuoteSliderOptions);

			var scienceManSliderOptions = {
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				asNavFor: $dom.scienceManSliderNav,
				infinite: false,
				speed: 100,
				fade: true,
				responsive: [{
					breakpoint: 1023,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						arrows: false,
						infinite: true,
						fade: false,
						adaptiveHeight: true
					}
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						arrows: false,
						infinite: true,
						fade: false,
						adaptiveHeight: true
					}
				}]
			};

			var scienceManSliderNavOptions = {
				dots: false,
				arrows: false,
				slidesToShow: 5,
				slidesToScroll: 5,
				focusOnSelect: true,
				asNavFor: $dom.scienceManSlider,
				infinite: false,
				fade: false
			};

			$dom.scienceManSlider.on('init', function (event, slick) {
				$(this).append('<div class="slider-count"><p><span id="current">1</span>/<span id="total">' + slick.slideCount + '</span></p></div>');
			});

			$dom.scienceManSlider.slick(scienceManSliderOptions);

			$dom.scienceManSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
				// finally let's do this after changing slides
				$('.slider-count #current').html(currentSlide + 1);
				$('.c-scienceManVcol__video iframe').each(function () {
					$(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
				});
			});

			$dom.scienceManSliderNav.slick(scienceManSliderNavOptions);
		};

		var slickActive = false;
		var MobileSlidersInit = function MobileSlidersInit() {
			var pressLogoSliderSettings = {
				dots: true,
				arrows: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 3500,
				mobileFirst: true,
				pauseOnChange: true,
				responsive: [{
					breakpoint: 640,
					settings: "unslick"
				}]
			};

			var productOptions = {
				dots: true,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				adaptiveHeight: true
			};

			if ($(window).width() < 640) {
				if (slickActive == false) {
					$dom.productMobileSlider.length > 0 && $dom.productMobileSlider.slick(productOptions);
					$dom.pressLogoSlider.length > 0 && $dom.pressLogoSlider.slick(pressLogoSliderSettings);
					slickActive = true;
					// when the press logo slider is interacted with, remove autoplay
					$dom.pressLogoSlider.on('swipe', function (event, slick, direction) {
						$dom.pressLogoSlider.slick('slickSetOption', 'autoplay', false);
					});
				}
			} else {
				if (slickActive == true) {
					$dom.productMobileSlider.length > 0 && $dom.productMobileSlider.slick('destroy');
					$dom.pressLogoSlider.length > 0 && $dom.pressLogoSlider.slick('destroy');
				}
				slickActive = false;
			}
		};

		var bindUIActions = function bindUIActions() {
			$dom.testimonialSliderLogos.hover(function () {
				$dom.testimonialSliderQuotes.slick('slickPause');
				$dom.testimonialSliderLogos.slick('slickPause');
			}, function () {
				$dom.testimonialSliderQuotes.slick('slickPlay');
				$dom.testimonialSliderLogos.slick('slickPlay');
			});
		};

		Sliders.init = function () {
			cacheDom();
			SlidersInit();
			$(window).on('load', function () {
				MobileSlidersInit();
			});
			$(window).resize(function () {
				MobileSlidersInit();
			});
			bindUIActions();
		};
	})(window.Sliders = window.Sliders || {}, _jquery2.default, undefined);
};